module.exports = __webpack_public_path__ + "static/media/powerbar.577b9dcb.svg";